import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { api } from 'lib/httpClient';
import { ApiResponse, SuccessResponse } from 'further-types/api';
import { useNotification } from 'hooks/ui/useNotification';

async function updateAllocation(id, data) {
  const { data: response } = await api.put(`allocations/${id}`, data);
  return response;
}

const useAllocationUpdateAPI = ({ params }) => {
  const queryClient = useQueryClient();
  return useMutation<
    unknown,
    unknown,
    {
      taxReliefElegible: boolean;
      lostReliefDate: Date | null;
      notifyInvestors?: boolean;
    }
  >({
    mutationFn: (data) => updateAllocation(params.id, data),
    onSuccess: async () => {
      queryClient.invalidateQueries({
        queryKey: ['allocations'],
      });
      queryClient.invalidateQueries({
        queryKey: ['eis-tasklist'],
      });
    },
  });
};

const useAllocationDelete = () => {
  const queryClient = useQueryClient();
  const { error } = useNotification();
  return useMutation<
    SuccessResponse,
    AxiosError<ApiResponse<SuccessResponse>>,
    { id: string }
  >({
    mutationFn: async (data) => {
      const { data: response } = await api.delete(`allocations/${data.id}`);
      return response;
    },
    onSuccess: async () =>
      queryClient.invalidateQueries({
        queryKey: ['allocations'],
      }),
    onError: (err) => {
      error(err.response?.data?.responseMsg ?? 'Something went wrong.');
    },
  });
};

export function useAllocation(params) {
  const update = useAllocationUpdateAPI(params);

  return {
    update,
    delete: useAllocationDelete(),
  };
}
